import styled from 'styled-components';

export const Wrapper = styled.div`
  background-color: var(--black-200);
  width: 100%;
  position: relative;
  border-radius: 6px;

  &.skeletonWrapper {
    cursor: progress;
  }
`

export const Body = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  border: 1px solid #3d3d3d;
`

export const OccurrenceColumn = styled.div`
  padding: 1rem;
  border-right: 1px solid #3d3d3d;
`

export const OccurrenceHeader = styled.div`
  display: flex;
  justify-content: space-between;
`

export const HeaderBody = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  h4 {
    font-size: 1rem;
  }

  button {
    width: 34px;
    height: 34px;

    background-color: var(--primary);
    
    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 4px;
  }
`

export const HeaderBodyInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  background-color: var(--black-100);
  border-radius: 4px;
`

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 0.8rem;
  h4:last-of-type {
    color: var(--primary);
    cursor: pointer;
    
    &:hover {
      text-decoration: underline;
    }
  }
`

export const Column = styled.div`
    display: flex;
    flex-direction: column;
    padding: 1rem;
`

export const EmptyContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 100%;

  h3 {
    font-size: 0.95rem;
  }
`

export const ManualBadgeContainer = styled.div`
 margin: 0rem 1rem;
`

export const ManualBadge = styled.div`
  width: 100%;
  padding: 0.5625rem 0.75rem;
  text-align: center;
  border-radius: 6.25rem;
  font-size: 0.8rem;
  font-family: DM Sans;
  min-height: 2rem;
  margin-top: 1rem;
  justify-content: center;
  color: var(--primary);
  background: var(--darker-primary);

  &.working {
    color: var(--green);
    background-color: rgba(99, 204, 57, 0.16);
  }
`

export const FooterButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 1rem;
  button {
    font-size: 0.88rem;
    height: 37px;
    width: 100%;
    padding: 0rem 1.3rem;
    margin-right: 0.5rem;
    
    font-family: DM Sans, sans-serif;
    &:last-child {
      margin-right: 0rem;
      background-color: var(--black-400);
      color: var(--white);
      font-weight: 500;
    }
    &:hover {
      opacity: 0.9;
    }
  }
`

export const CloseButton = styled.button`
  background-color: var(--black-400);
  padding: 0rem;
  width: 30px;
  height: 30px;
  border-radius: 100%;
  margin-left: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.4s;
  position: absolute;
  top: 12px;
  right: 12px;

  &:hover {
    background-color: var(--black-100);
  }

  img {
    width: 20px;
    height: 20px;
  }
`